import { IconProps } from ".";

export const EditIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46121 0.285825C6.85054 -0.097836 7.47761 -0.0948843 7.86331 0.292424L9.21145 1.64622C9.59428 2.03065 9.59645 2.65064 9.21633 3.03773L4.36872 7.97421C3.90885 8.44251 3.30808 8.74708 2.65852 8.84122L1.63607 8.98941C0.964144 9.0868 0.394652 8.49763 0.516546 7.83121L0.722568 6.70483C0.833517 6.09825 1.1287 5.54058 1.56793 5.10776L6.46121 0.285825ZM7.25956 0.8909C7.20446 0.83557 7.11488 0.835149 7.05926 0.889957L6.61584 1.32691L8.16789 2.89207L8.6084 2.44348C8.66271 2.38818 8.66239 2.29961 8.60771 2.24469L7.25956 0.8909ZM7.5722 3.49868L6.01033 1.9236L1.88109 5.99264L3.46372 7.68248L7.5722 3.49868ZM2.58986 7.99314L1.5543 6.88742L1.35379 7.98365C1.33638 8.07885 1.41773 8.16302 1.51372 8.14911L2.58986 7.99314Z"
        fill="currentColor"
      />
    </svg>
  );
};
